
export const apiPath = {
    accessTokenKey: 'SSAuth',

    authLogin:'auth/Login',

    getRates:'PitneyBowes/GetRateshop',
    getBoxSizes:'PickUp/GetBoxSizes',
    getShipments:'PitneyBowes/GetAllShipments',
    getSaleOrders:'Sales/GetAllSalesOrderByProc',
    getSaleOrdersPag:'Sales/GetAllSalesOrders',
    printDocument:'PitneyBowes/PrintDocument',
    getRateSetups:'RateSetup/GetAllRateSetupByProc',
    getShipmentbyID:'PitneyBowes/GetShipmentById',
    getRateSetupbyID:'RateSetup/GetSingleRateSetupById',
    createShipment:'PitneyBowes/CreateShipmentDomestic',
    createRateSetup:'RateSetup/AddEditRateSetup',
    getAllProdcutDimensionsByProc:'Product/GetAllProdcutDimensionsByProc',
    getSingleProductDimensions:'Product/GetSingleProductDimensions',
    addEditProdcutDimensions:'Product/AddEditProdcutDimensions',

    getPackingSlips:'Report/GetPackingSlips',
    activeInactiveRateSetup:'RateSetup/ActiveInactiveRateSetup',

    getCountries:'Address/GetAllCountries',
    getStates:'Address/GetAllStates',
    getCities:'Address/GetAllCities',
    getStoreAddress:'Address/GetStoreAddress',
}


export const MessageTypes = {
    error: "Error",
    info: "Info",
    failure: "Failure",
    success: "Success",
    warning: "Warning",
}

export const ResultMessages = {
    serverError: "Internal Server Error",
    requiredAllField: "Please fill all feilds",
    fileSizeLimit: "File size can not be more than 1 MB.",
    fileExtension: "File Format not supported",
    fileNotFound: "Sorry, we are unable to download this file for you.",
}
